import React, { useState, useEffect } from 'react';
import {
    Text, View, Image, ScrollView, StyleSheet,
    ImageBackground, TouchableHighlight, Pressable, TextInput
} from 'react-native';

import * as AlertService from "../../utils/services/AlertLoaderService";
import * as CommonUtils from '../../utils/services/CommonUtils';
import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import OmsStyles from '../../OmsStyle';

const WalletNetBankingModesList = (props) => {

    const [showAlert, setShowAlert] = useState(false);
    const [payableAmount, updatePayableAmount] = useState(props.route?.params.payableAmount);
    const [netBankingModes, setNetBankingModes]: any = useState([]);
    const [filteredNetBankModes, setFilteredNetBankModes]: any = useState([]);

    const [walletModes, serWalletModes]: any = useState(null);
    const [searchedMode, setSearchedMode]: any = useState('');

    useEffect(() => {
        setNetBankingModes(props.route?.params?.netBankingModes);
        setFilteredNetBankModes(props.route?.params?.netBankingModes);
        serWalletModes(props.route?.params?.walletModes);
    }, []);

    const searchNetBankModesList = (modeName) => {
        if (modeName.length !== 0) {
            let setNetBankingModes = netBankingModes.filter((item) => item.endn.toLocaleLowerCase().includes(modeName) || item.service.toLocaleLowerCase().includes(modeName))
            setFilteredNetBankModes(setNetBankingModes);
        } else setFilteredNetBankModes(netBankingModes)
    }

    const onPressMode = (mode) => {
        props.route?.params?.makeOnlinePayment(mode);
        global.appHandledBackpress = true;
        props.navigation.pop();
    }

    return (
        <View style={{ flex: 1, width: AppTheme.appWidth, height: '100%', minHeight: '100vh' }}>
            <CommonHeader navigation={props.navigation} allowPopScreen={true} title={` ${payableAmount ? `To Pay: ${payableAmount}` : 'Net Banking'}`}></CommonHeader>

            <View style={{ marginTop: AppTheme.headerHeight, margin: 16, paddingTop: 17 }}>
                {!!netBankingModes && <View style={[AppStyles.flexRowSpaceBetween, { borderColor: 'rgba(0, 0, 0, 0.12)', borderWidth: 1, }]}>
                    <Image source={{ uri: CommonUtils.getImagePath('/images/icons/search_blue.svg') }} style={styles.searchIcon} />
                    <TextInput
                        style={[OmsStyles.text14, styles.searchInput]}
                        placeholderTextColor={AppTheme.color.fillerInfo}
                        placeholder="Search for bank"
                        underlineColorAndroid="transparent"
                        maxLength={80}
                        value={searchedMode}
                        onChangeText={(text) => { setSearchedMode(text.toLocaleLowerCase()); searchNetBankModesList(text.toLocaleLowerCase()) }} />
                    {searchedMode.length ?
                        <Text onPress={() => { setSearchedMode(''); searchNetBankModesList('') }}> <Image source={{ uri: CommonUtils.getImagePath('/images/oms/cancel-search.svg') }} style={[{ height: 22, width: 22, marginRight: 10, }]} /></Text>
                        : null
                    }
                </View>}

                <View >
                    {
                        netBankingModes ? <View style={{ marginTop: 16 }}>
                            {filteredNetBankModes.map((item, index) => (
                                <Pressable key={item} onPress={() => { onPressMode(item) }}
                                    onLongPress={() => { console.log('### long press') }}
                                    style={{ borderWidth: 1, borderColor: 'rgba(235, 235, 235, 1)', padding: 16 }}>
                                    <View style={AppStyles.flexRowSpaceBetween}>
                                        {/* <Image source={{ uri: item?.icon }} style={{ width: 38, height: 38, borderWidth: 3, borderColor: AppTheme.color.primary, borderRadius: 50 }} /> */}
                                        <Text numberOfLines={1} ellipsizeMode='head' key={index}>{item['endn']}</Text>
                                        <Image source={{ uri: CommonUtils.getImagePath('/images/oms/right_lg_dark_chevron.svg'), height: 18, width: 10 }} />
                                    </View>
                                    {/* <View style={styles.hr}></View> */}
                                </Pressable>
                            ))}
                        </View> : walletModes ? <View>
                            {walletModes.map((item, index) => (
                                <Pressable key={item} onPress={() => { onPressMode(item) }}
                                    onLongPress={() => { console.log('### long press') }}
                                    style={{ borderWidth: 1, borderColor: 'rgba(235, 235, 235, 1)', paddingVertical: 18, paddingHorizontal: 12 }}>
                                    <View style={AppStyles.flexRow}>
                                        <Image style={[styles.modeIcon, { borderWidth: item.icon === null ? 0 : 3 }]} source={{ uri: item?.icon ? item.icon : CommonUtils.getImagePath(`/images/oms/rops/icons/${item.service}.svg`) }} />
                                        <Text style={[OmsStyles.text14, { paddingLeft: 6 }]} numberOfLines={1} ellipsizeMode='head' key={index}>{item['endn']}</Text>
                                        {/* <Image source={{ uri: CommonUtils.getImagePath('/images/oms/right_lg_dark_chevron.svg'), height: 18, width: 10 }} /> */}
                                    </View>
                                </Pressable>

                            ))}
                        </View> : null
                    }
                </View>
            </View>

        </View >
    )
}

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    modeIcon: { width: 28, height: 28, borderColor: AppTheme.color.primary, borderRadius: 50 },

    searchInput: { borderRadius: 8, flexGrow: 1, paddingVertical: 10, paddingHorizontal: 16, color: 'rgba(0, 0, 0, 0.38)', },
    searchIcon: { width: 18, height: 18, marginLeft: 10, marginVertical: 15 },
    container: {
        flex: 1,
    },
    hr: {
        backgroundColor: 'rgba(235, 235, 235, 1)',
        height: 2,
        position: 'relative',
        left: -17,
        width: '100vw',
        marginVertical: 16
    },
    subTitle: {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 16,
        color: '#000000',
        paddingBottom: 5
    },
    modesTitle: {
        fontSize: 16,
        fontWeight: '700',
        lineHeight: 19,
        letterSpacing: 0,
        textAlign: 'left',
        paddingBottom: 16

    },

}))

export default WalletNetBankingModesList;